import React, { Component } from "react";
import "./Services.css";
import Footer from "../../components/Footer/Footer";
import ContactUsFooter from "../../components/ContactUsFooter/contactUsFooter";
import { Link } from 'react-router-dom';


export default class Services extends Component {
    render() {
        return (
            <div>
                <section className="core-services">
                    <div className="header-section">
                        <h1>
                            <span className="highlight">Digital Transformation</span><br /> &
                            Technology Solutions
                        </h1>
                        <p className="intro">
                            At Ambrum, we transform ambitious ideas into digital realities
                            blending smart software solutions with impactful marketing to shape the future of business.
                        </p>
                        <Link to="/talk-to-us" className="cta-link">
                            Book a free consultation ›
                        </Link>
                    </div>

                    <div className="section-divider" />

                    <div className="core-service">
                        <Link to="/services/software-mobile" style={{ textDecoration: 'none', color: 'inherit' }}>
                            <div className="core-card">
                                <div className="core-text">
                                    <h3 className="hero-text">Custom Software &<br />Mobile App Development</h3>
                                    <p>
                                        We develop scalable web and mobile applications, including ERP, CRM, and automation solutions,
                                        tailored to business needs. Our expertise ensures seamless integration, security, and
                                        user-friendly experiences that drive efficiency and growth.
                                    </p>
                                </div>
                                <img src="./assets/images/laptop.gif" className="smart-city-icon"  alt="Custom Software Icon" />
                            </div>
                        </Link>

                        <div className="section-divider" />

                        <Link to="/services/sub-services?service=smart-city" style={{ textDecoration: 'none', color: 'inherit' }}>
                            <div className="core-card">
                                <img src="./assets/images/map.gif" alt="Smart City Icon" className="smart-city-icon" />
                                <div className="core-text">
                                    <h3 className="hero-text" >Smart City &<br />Infrastructure Solutions</h3>
                                    <p>
                                        Ambrum builds IoT-enabled smart city solutions, enhancing urban management,
                                        transportation, and service provider platforms. Our work in Port City demonstrates our ability
                                        to create digital ecosystems that improve city administration and citizen experiences.
                                    </p>
                                </div>
                            </div>
                        </Link>

                        <div className="section-divider" />


                        <Link to="/services/sub-services?service=ev-charging" style={{ textDecoration: 'none', color: 'inherit' }}>
                            <div className="core-card">
                                <div className="core-text">
                                    <h3 className="hero-text">EV Charging & Sustainable<br />Tech Solutions</h3>
                                    <p>
                                        We provide smart EV charging solutions like Voltcharge, offering real-time monitoring,
                                        payment integration, and analytics for businesses adopting sustainable energy.
                                        Our technology ensures a seamless, scalable, and efficient EV charging infrastructure.
                                    </p>
                                </div>
                                <img src="./assets/images/charging-station.gif" alt="Custom Software Icon" />
                            </div>
                        </Link>

                        <div className="section-divider" />

                        <Link to="/services/sub-services?service=healthcare" style={{ textDecoration: 'none', color: 'inherit' }}>
                            <div className="core-card">
                                <img src="./assets/images/doctors-office.gif" alt="Smart City Icon" className="smart-city-icon"  />
                                <div className="core-text">
                                    <h3 className="hero-text" >Healthcare &<br />E-Channeling Solutions</h3>
                                    <p>
                                        Our healthcare solutions, including Find My Doc, enable doctor booking, medical record tracking,
                                        and telemedicine services. We empower hospitals and clinics with secure, user-friendly
                                        platforms that enhance patient engagement and streamline operations.
                                    </p>
                                </div>
                            </div>
                        </Link>

                        <div className="section-divider" />

                        <Link to="/services/sub-services?service=e-ticketing" style={{ textDecoration: 'none', color: 'inherit' }}>
                            <div className="core-card">
                                <div className="core-text">
                                    <h3 className="hero-text">E-Ticketing & Event<br />Management Solutions</h3>
                                    <p>
                                        We develop seamless e-ticketing and event management platforms, offering real-time sales,
                                        secure payments, and audience insights. Our solutions ensure a smooth experience for
                                        both organizers and attendees, optimizing event success.
                                    </p>
                                </div>
                                <img src="./assets/images/tickets.gif" alt="Custom Software Icon" className="smart-city-icon"  />
                            </div>
                        </Link>

                        <div className="section-divider" />

                        <Link to="/services/sub-services?service=digital-marketing" style={{ textDecoration: 'none', color: 'inherit' }}>
                            <div className="core-card">
                                <img src="./assets/images/advertising.gif" alt="Smart City Icon" className="smart-city-icon" />
                                <div className="core-text">
                                    <h3 className="hero-text" >Performance-Driven<br />Digital Marketing</h3>
                                    <p>
                                        We execute ROI-focused digital marketing strategies, including SEO,
                                        paid ads (Google, Meta, TikTok, LinkedIn), and conversion optimization.
                                        Our data-driven approach ensures maximum reach, engagement, and sales.
                                    </p>
                                </div>
                            </div>
                        </Link>

                        <div className="section-divider" />

                        <Link to="/services/sub-services?service=brand-strategy" style={{ textDecoration: 'none', color: 'inherit' }}>
                            <div className="core-card">
                                <div className="core-text">
                                    <h3 className="hero-text">Brand Strategy & Identity <br />Development</h3>
                                    <p>
                                        Ambrum crafts powerful brand identities through strategic positioning, messaging,
                                        and creative design. Our IMC campaigns ensure businesses establish a strong,
                                        differentiated presence in the market.
                                    </p>
                                </div>
                                <img src="./assets/images/blueprint.gif" alt="Custom Software Icon" className="smart-city-icon"  />
                            </div>
                        </Link>

                        <div className="section-divider" />

                        <Link to="/services/sub-services?service=social-media" style={{ textDecoration: 'none', color: 'inherit' }}>
                            <div className="core-card">
                                <img src="./assets/images/content-media.gif" alt="Smart City Icon" className="smart-city-icon" />
                                <div className="core-text">
                                    <h3 className="hero-text" >Content & Social Media <br />Growth</h3>
                                    <p>
                                        We create engaging content, manage social media, and leverage influencer marketing
                                        to grow digital communities. Our storytelling approach enhances brand visibility,
                                        engagement, and audience loyalty.
                                    </p>
                                </div>
                            </div>
                        </Link>

                        <div className="section-divider" />

                        <Link to="/services/sub-services?service=e-commerce" style={{ textDecoration: 'none', color: 'inherit' }}>
                            <div className="core-card">
                                <div className="core-text">
                                    <h3 className="hero-text">E-Commerce & <br />Conversion Optimization</h3>
                                    <p>
                                        Our e-commerce strategies boost online sales through store optimization,
                                        sales funnel development, and marketing automation. We maximize conversion
                                        rates with data-driven growth solutions.
                                    </p>
                                </div>
                                <img src="./assets/images/online-shopping.gif" alt="Custom Software Icon" />
                            </div>
                        </Link>


                        <ContactUsFooter />

                    </div>
                </section>
                <Footer />
            </div>
        );
    }
}
